import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

const HERO_PHOTOS = [
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/c9a97e95-b74f-4797-9154-6f23bb4d807d_PrimaryPhoto.jpg?v=396558a83e0049f45638898b231d8e6b",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/89b04a93-f321-45fc-a25b-8bb689a7ba29_property-name_002.jpg?v=5810a894d4d2b61aaf60196d5cf82a62",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/fa354956-a414-4dbe-b80d-771f0d7bc87f_property-name_016.jpg?v=c6e81606912827bae05f533c0abeb09d",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/43977777-c046-4b44-991d-b7dddf072771_property-name_009.jpg?v=5a532d675d22618802164a2d02cffa5c",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/85f51bb4-f263-4504-8231-442f33f647df_InteriorPhoto-1_web.jpg?v=01ed39b25aa49abe421f23bb28f433e6",
];

const PORTFOLIO_PHOTOS = [
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/c9a97e95-b74f-4797-9154-6f23bb4d807d_PrimaryPhoto.jpg?v=396558a83e0049f45638898b231d8e6b",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/89b04a93-f321-45fc-a25b-8bb689a7ba29_property-name_002.jpg?v=5810a894d4d2b61aaf60196d5cf82a62",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/d5656e33-7543-4aca-b71e-05d91669f9b5_BuildingPhoto-1.jpg?v=c991c799159fe7ec1604cf65cd8f0fe2",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/43977777-c046-4b44-991d-b7dddf072771_property-name_009.jpg?v=5a532d675d22618802164a2d02cffa5c",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/85f51bb4-f263-4504-8231-442f33f647df_InteriorPhoto-1_web.jpg?v=01ed39b25aa49abe421f23bb28f433e6",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/fa354956-a414-4dbe-b80d-771f0d7bc87f_property-name_016.jpg?v=c6e81606912827bae05f533c0abeb09d",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/d5656e33-7543-4aca-b71e-05d91669f9b5_BuildingPhoto-1.jpg?v=c991c799159fe7ec1604cf65cd8f0fe2",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/2dff933c-d312-48b8-8959-0dfd6f5c7b89_property-name_020.jpg?v=69eb0f9a90099faab54a3b9307b848d7",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/84e85628-2e92-409d-a8ee-5e0b8729b261_InteriorPhoto-2_web.jpg?v=1b8f98ec414de1fc3974df29487c817f",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/af05dacd-4efd-40a2-a4fa-d99dd4b4b800_property-name_029.jpg?v=4491c1af80cb15b782b4d9addc93d09f",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/9f48bb01-8b76-4078-8e06-db235e4f4d4a_InteriorPhoto-3_web.jpg?v=49e8571f560e59c8bbb4ed9f32785da9",
  "https://storage.readdy-site.link/project_files/bac881ec-b9cc-4710-87b9-9f51b6eb607d/b96bd280-8fc3-4b70-9f41-e84e83ce753d_InteriorPhoto-5.jpg?v=9c4cb74b2789486dab8246131e2d6931",
];

const STATS = [
  { value: "300+", label: "Properties Developed" },
  { value: "$150M+", label: "Total Project Value" },
  { value: "40+", label: "Years Combined Experience" },
];

const SERVICES = [
  {
    icon: "ri-hammer-line",
    title: "Residential Redevelopment",
    desc: "We identify undervalued properties and transform them into stunning, move-in-ready homes — maximizing value and turning vision into reality.",
  },
  {
    icon: "ri-building-line",
    title: "New Construction",
    desc: "From the ground up, we design and build custom high-end residences tailored to the modern buyer's lifestyle and expectations.",
  },
  {
    icon: "ri-medal-line",
    title: "Premium Finishes",
    desc: "Every property receives top-tier materials, curated design selections, and meticulous craftsmanship that sets our work apart.",
  },
];

function useInView(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return { ref, visible };
}

function HeroCollage() {
  return (
    <section className="relative h-screen min-h-[700px] overflow-hidden">
      {/* Asymmetric photo collage — pure flexbox */}
      <div className="absolute inset-0 flex" style={{ gap: "6px", padding: "6px" }}>

        {/* LEFT — one tall photo */}
        <div className="relative overflow-hidden" style={{ flex: "0 0 40%" }}>
          <img src={HERO_PHOTOS[0]} alt="Premium property" className="w-full h-full object-cover object-top scale-105 hover:scale-100 transition-transform duration-1000" />
        </div>

        {/* RIGHT — two rows stacked */}
        <div className="flex flex-col" style={{ flex: 1, gap: "6px" }}>

          {/* Top row */}
          <div className="flex" style={{ flex: 1, gap: "6px" }}>
            <div className="relative overflow-hidden" style={{ flex: 2 }}>
              <img src={HERO_PHOTOS[1]} alt="Property detail" className="w-full h-full object-cover object-top scale-105 hover:scale-100 transition-transform duration-1000" />
            </div>
            <div className="relative overflow-hidden" style={{ flex: 1 }}>
              <img src={HERO_PHOTOS[2]} alt="Interior finish" className="w-full h-full object-cover object-top scale-105 hover:scale-100 transition-transform duration-1000" />
            </div>
          </div>

          {/* Bottom row */}
          <div className="flex" style={{ flex: 1, gap: "6px" }}>
            <div className="relative overflow-hidden" style={{ flex: 1 }}>
              <img src={HERO_PHOTOS[3]} alt="Architectural feature" className="w-full h-full object-cover object-top scale-105 hover:scale-100 transition-transform duration-1000" />
            </div>
            <div className="relative overflow-hidden" style={{ flex: 2 }}>
              <img src={HERO_PHOTOS[4]} alt="Living space" className="w-full h-full object-cover object-top scale-105 hover:scale-100 transition-transform duration-1000" />
            </div>
          </div>

        </div>
      </div>

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/10" />

      {/* Hero Text */}
      <div className="absolute inset-0 flex items-end pb-20 px-10 md:px-20">
        <div className="max-w-3xl w-full">
          <p className="text-amber-400 text-xs font-semibold tracking-[0.35em] uppercase mb-5 opacity-0 animate-[fadeInUp_0.8s_0.3s_forwards]">
            Luxury Real Estate Development
          </p>
          <h1 className="text-white font-serif leading-none mb-6 opacity-0 animate-[fadeInUp_0.8s_0.5s_forwards]">
            <span className="block text-6xl md:text-8xl font-bold">Transforming Properties.</span>
            <span className="block text-5xl md:text-7xl font-light italic text-amber-300 ml-4">Building Exceptional Homes.</span>
          </h1>
          <p className="text-white/80 text-lg mb-10 max-w-lg leading-relaxed opacity-0 animate-[fadeInUp_0.8s_0.7s_forwards]">
            Premium residential redevelopment and new construction across Long Island — quality homes built to stand the test of time.
          </p>
          <div className="flex gap-4 flex-wrap opacity-0 animate-[fadeInUp_0.8s_0.9s_forwards]">
            <Link
              to="/about"
              className="whitespace-nowrap px-8 py-4 bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold tracking-widest uppercase rounded-full transition-all duration-300 cursor-pointer"
            >
              About Us
            </Link>
            <Link
              to="/contact"
              className="whitespace-nowrap px-8 py-4 border border-white/70 hover:border-white text-white text-sm font-semibold tracking-widest uppercase rounded-full transition-all duration-300 hover:bg-white/10 cursor-pointer"
            >
              Get in Touch
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  const { ref, visible } = useInView();
  return (
    <section ref={ref} className="bg-stone-900 py-16 px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            className={`text-center transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
            style={{ transitionDelay: `${i * 120}ms` }}
          >
            <div className="text-4xl md:text-5xl font-bold text-amber-500 font-serif mb-2">{s.value}</div>
            <div className="text-stone-400 text-sm tracking-wider uppercase">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

function ServicesSection() {
  const { ref, visible } = useInView();
  return (
    <section ref={ref} className="bg-stone-50 py-28 px-8">
      <div className="max-w-7xl mx-auto">
        <div
          className={`mb-16 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
        >
          <p className="text-amber-700 text-xs font-semibold tracking-[0.3em] uppercase mb-4">Our Expertise</p>
          <h2 className="text-4xl md:text-5xl font-bold font-serif text-stone-900 leading-tight">
            Built With Purpose,<br /><em className="font-light">Finished With Pride</em>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {SERVICES.map((s, i) => (
            <div
              key={s.title}
              className={`bg-white rounded-2xl p-10 border border-stone-100 hover:border-amber-200 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
              style={{ transitionDelay: `${i * 150 + 200}ms` }}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-amber-50 mb-6">
                <i className={`${s.icon} text-2xl text-amber-700`} />
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-3">{s.title}</h3>
              <p className="text-stone-500 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function PortfolioSection() {
  const { ref, visible } = useInView();
  return (
    <section ref={ref} className="bg-white py-28 px-8">
      <div className="max-w-7xl mx-auto">
        <div
          className={`text-center mb-16 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
        >
          <p className="text-amber-700 text-xs font-semibold tracking-[0.3em] uppercase mb-4">Our Portfolio</p>
          <h2 className="text-4xl md:text-5xl font-bold font-serif text-stone-900">Featured Properties</h2>
        </div>
        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 space-y-5">
          {PORTFOLIO_PHOTOS.map((src, i) => (
            <div
              key={i}
              className={`break-inside-avoid rounded-xl overflow-hidden transition-all duration-700 group ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
              style={{ transitionDelay: `${i * 100 + 200}ms` }}
            >
              <div className="relative overflow-hidden">
                <img
                  src={src}
                  alt={`Property ${i + 1}`}
                  className="w-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-4 left-4 right-4 text-white opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
                  <p className="text-xs font-semibold tracking-widest uppercase text-amber-300">Premium Property</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  const { ref, visible } = useInView();
  return (
    <section ref={ref} className="py-28 px-8 bg-stone-50">
      <div
        className={`max-w-4xl mx-auto text-center transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
      >
        <p className="text-amber-700 text-xs font-semibold tracking-[0.3em] uppercase mb-6">Long Island Residential Development</p>
        <h2 className="text-5xl md:text-6xl font-bold font-serif text-stone-900 leading-tight mb-6">
          Homes Built With<br /><em className="font-light text-amber-700">Uncompromising Quality</em>
        </h2>
        <p className="text-stone-500 text-lg mb-12 max-w-xl mx-auto leading-relaxed">
          Every Havinar Homes property is designed, built, and finished to the highest standard — because the homes we put our name on reflect who we are.
        </p>
        <Link
          to="/contact"
          className="whitespace-nowrap inline-block px-12 py-5 bg-stone-900 hover:bg-amber-700 text-white text-sm font-semibold tracking-widest uppercase rounded-full transition-all duration-300 cursor-pointer"
        >
          Learn More &rarr;
        </Link>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroCollage />
      <StatsSection />
      <ServicesSection />
      <PortfolioSection />
      <CTASection />
      <Footer />
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Inter:wght@300;400;500;600&display=swap');
        body { font-family: 'Inter', sans-serif; }
        .font-serif { font-family: 'Playfair Display', Georgia, serif; }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </main>
  );
}
